module.exports = __webpack_public_path__ + "img/interview_influencer_image.cd6828ee.png";